export const NUMBER_DETECT_CROP = {
  widthRatio: 0.6,
  heightRatio: 0.4,
};
